// Auto generated file, do not manually modify!
// com.hotpads.capps.handler.web.renter.v1.CappsSplitWebApiHandler

import type { UseQueryOptions } from '@zg-rentals/react-query5';
import { useQuery } from '@zg-rentals/react-query5';
import { tsClientOptions } from '@zg-rentals/react-query5';
import type { Client } from '@zg-rentals/http-client';
import {
  CappsSplitWebApiHandler_getTreatment,
  CappsSplitWebApiHandler_getTreatment_Path,
} from '@zg-rentals/ts-capps-client';

import type { SplitGetTreatmentResponseDto } from '@zg-rentals/ts-capps-client';

interface GetTreatmentParams {
  featureName: string;
}

export type CappsSplitWebApiHandler_getTreatment_Options = UseQueryOptions<
  SplitGetTreatmentResponseDto,
  unknown,
  SplitGetTreatmentResponseDto,
  Array<string | GetTreatmentParams>
>;

const CappsSplitWebApiHandler_getTreatment_GetKey = (getParams: GetTreatmentParams) => [
  CappsSplitWebApiHandler_getTreatment_Path,
  getParams,
];

export const useCappsSplitWebApiHandler_getTreatment = (
  getParams: GetTreatmentParams,
  {
    httpClient,
    ...options
  }: Omit<CappsSplitWebApiHandler_getTreatment_Options, 'queryFn' | 'queryKey'> & { httpClient?: Client } = {},
) => {
  return useQuery({
    ...tsClientOptions.queryOptions,
    ...options,
    queryKey: CappsSplitWebApiHandler_getTreatment_GetKey(getParams),
    queryFn: () => CappsSplitWebApiHandler_getTreatment(getParams, httpClient),
  });
};
useCappsSplitWebApiHandler_getTreatment.getKey = CappsSplitWebApiHandler_getTreatment_GetKey;
